import { Route, Routes } from 'react-router-dom';

import { DetailNonCompliancePaymentsTaxpayer } from './views/DetailNonCompliancePaymentsTaxpayer';
import { NonCompliancePaymentsTaxpayers } from './views/NonCompliancePaymentsTaxpayers';
import { Statistics } from './views/Statistics';

export const CollectionsRouting = () => {
  return (
    <Routes>
      <Route
        path="view-process"
        element={
          <>
            {/*<ListProcess />*/}
            <NonCompliancePaymentsTaxpayers />
          </>
        }
      />
      <Route path="view-process/:id" element={<DetailNonCompliancePaymentsTaxpayer />} />

      <Route path="statistics" element={<Statistics />} />

      {/*<Route path="payments" element={...}>*/}
      {/*   */}
      {/*</Route>*/}
      {/*<Route path="payments/:id" element={<DetailNonCompliancePaymentsTaxpayer />}>*/}
      {/*    */}
      {/*</Route>*/}
    </Routes>
  );
};
